'use strict';

var app = app || angular.module('harriApp');

app.factory('httpHelper', ['$http', '$q', '$injector', function ($http, $q, $injector) {

    var http={};


    http.$http = function(){
        return $http;
    };

    /**
     * Get
     * @param url
     * @returns {HttpPromise}
     */
    http.g = function(url, cache, headers) {
        if(!cache) cache = false;

        if(url.indexOf('://') < 0) {
            url = publicConfiguration.APIServerBaseURL + url;
        }

        return $http.get(url, {
            withCredentials: true,
            cache : cache,
            headers: headers
        });
    };

    /**
     * @TODO docs
     *
     * @param url
     * @param cache
     * @param body
     * @returns {*}
     */
    http.safePost = function(url, body, cache) {
        var defer = $q.defer();
        http.p(url, body, false, 'POST', cache).then(function(data) {
            defer.resolve(data);
        }, function(err) {
            defer.resolve({data:{}, "status_code": "request canceled", "status":"request canceled"});
        });

        return defer.promise;
    };



    /**
     * @TODO docs
     *
     * @param url
     * @param cache
     * @returns {*}
     */
    http.safeGet = function(url, cache, headers) {
        var defer = $q.defer();

        http.g(url, cache, headers).then(function(data) {
            defer.resolve(data);
        }, function(err) {
            defer.resolve({data:{}, "status_code": "request canceled", "status":"request canceled"});
        });

        return defer.promise;
    };


    /**
     * Delete
     * @param url
     * @returns {HttpPromise}
     */
    http.d = function(url) {
        return $http.delete( publicConfiguration.APIServerBaseURL + url, {
            withCredentials: true
        });
    };


    /**
     * Post helper
     * @param url
     * @param params
     * @returns {*}
     */
    http.p = function(url, params, withCredentials, method, cache) {
        if(!cache) cache = false;

        var reqUrl;
        method  = method || 'POST';
        reqUrl = url.indexOf('://') === -1? publicConfiguration.APIServerBaseURL + url:url;
        withCredentials = (withCredentials === false) ? withCredentials : true;
        return  $http({
            url: reqUrl,
            method: method,
            withCredentials: withCredentials,
            headers: { 'Content-Type': 'application/json' },
            data: params,
            cache : cache
        });
    };

    /**
     * PUT helper
     * @param url
     * @param params
     * @returns {*}
     */
    http.put = function(url, params, withCredentials) {
       return http.p( url, params, withCredentials, 'PUT');
    };

    http.$http = function(httpObj) {
        var url = httpObj.url;
        if(url.indexOf("://")>=0 && url.indexOf("http") != 0) {
            url = url.split("://");
            return http.$api(url[0], url[1], httpObj.data);
        }

        return $http(httpObj);
    };

    http.$api = function(service, method, data) {
        var $service = $injector.get(service);
        var defer = $q.defer();

        $service[method](data).then(function(r) {
            if(!r) r = {};

            if(r.data) {
                r = r.data;
            }

            if(!r.status_code) {
                r.status_code = 200;
            }

            defer.resolve(r);
        }, function(r) {

            if(r.data) {
                r = r.data;
            }

            if(!r.status_code) {
                r.status_code = 600;
            }

            defer.reject(r);
        });

        defer.promise.success = function(callback) {
            defer.promise.then(function(data) {
                var status_code = data.status_code || 200;
                callback(data, status_code, [], {})
            });
            return defer.promise;
        };

        defer.promise.error = function(callback) {
            defer.promise.then(function() {}, function(data) {
                callback(data, 600, [], {});
            });
            return defer.promise;
        };

        return defer.promise;
    };

    /**
     * @TODO docs
     *
     * @param url
     * @param mappingFunction
     * @returns {*}
     */
    http.getList = function(url, mappingFunction) {
        if(!mappingFunction) {
            //default mapping function
            mappingFunction = function(obj) {
                return {label: obj.name, value: obj.id};
            }
        }

        var defer = $q.defer();

            http.g(url, false).then(function(r) {
                if (r.data.status_code == 200) {
                    var data = r.data.data;
                    var result = [];

                    //re arrange data
                    _.each(data, function (item) {
                        var newValue = mappingFunction(item);

                        if(newValue) {
                            result.push(newValue);
                        }
                    });

                    defer.resolve(result);

                } else {
                    defer.reject(r);
                }
            }, function(r){
                defer.reject(r);
            });

        return defer.promise;
    };



    return http;

}]);
